/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComponentTwinsGroupResponseDto
 */
export interface ComponentTwinsGroupResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ComponentTwinsGroupResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentTwinsGroupResponseDto
     */
    groupName: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentTwinsGroupResponseDto
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ComponentTwinsGroupResponseDto
     */
    assetId: string;
    /**
     * Member ComponentSchema ids derived from join rows
     * @type {Array<string>}
     * @memberof ComponentTwinsGroupResponseDto
     */
    componentTwinsIds: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTwinsGroupResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ComponentTwinsGroupResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the ComponentTwinsGroupResponseDto interface.
 */
export function instanceOfComponentTwinsGroupResponseDto(value: object): value is ComponentTwinsGroupResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('componentTwinsIds' in value) || value['componentTwinsIds'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ComponentTwinsGroupResponseDtoFromJSON(json: any): ComponentTwinsGroupResponseDto {
    return ComponentTwinsGroupResponseDtoFromJSONTyped(json, false);
}

export function ComponentTwinsGroupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComponentTwinsGroupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'groupName': json['groupName'],
        'organizationId': json['organizationId'],
        'assetId': json['assetId'],
        'componentTwinsIds': json['componentTwinsIds'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function ComponentTwinsGroupResponseDtoToJSON(json: any): ComponentTwinsGroupResponseDto {
    return ComponentTwinsGroupResponseDtoToJSONTyped(json, false);
}

export function ComponentTwinsGroupResponseDtoToJSONTyped(value?: ComponentTwinsGroupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'groupName': value['groupName'],
        'organizationId': value['organizationId'],
        'assetId': value['assetId'],
        'componentTwinsIds': value['componentTwinsIds'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

